
class MandatoryAndStateSettingsService {

    static getSettingKey(stageId, roleId){
        return stageId + '_' + roleId;
    }

    static getStageSettingKey(stageId){
        return stageId + '_all';
    }

    static getRoleSettingKey(roleId){
        return 'all_' + roleId;
    }

    static getAllSettingKey(){
        return 'all_all';
    }

    static getSetting(opt){
        const
            stageId = opt.stageId,
            roleId = opt.roleId,
            settings = opt.settings,
            defaultValue = opt.defaultValue,
            settingsField = opt.settingsField,
            excludeIndividual = opt.excludeIndividual,
            excludeStage = opt.excludeStage,
            excludeRole= opt.excludeRole;


        let requiredValue = defaultValue;

        const individualSetting = this.getSettingKey(stageId, roleId);
        const stageAllSetting = this.getStageSettingKey(stageId);
        const roleAllSetting = this.getRoleSettingKey(roleId);
        const allSetting = this.getAllSettingKey();

        // settings value is either a js Map or a string like "all_all"
        if (settings && settings.has) {
            if (settings.has(individualSetting) && !excludeIndividual) {
                requiredValue = settings.get(individualSetting)[settingsField];

            } else if (settings.has(stageAllSetting) && !excludeStage) {
                requiredValue = settings.get(stageAllSetting)[settingsField];

            } else if (settings.has(roleAllSetting) && !excludeRole) {
                requiredValue = settings.get(roleAllSetting)[settingsField];

            } else if (settings.has(allSetting)) {
                requiredValue = settings.get(allSetting)[settingsField];
            }
        }

        // console.log(`==> requiredValue ${requiredValue}, stageId ${stageId}, roleId ${roleId}`);
        return requiredValue;
    }

    static createSetting(stageId, roleId, field, value){
        const setting = {stageId:stageId, roleId:roleId};
        setting[field] = value;

        if(stageId === 'all' && roleId === 'all'){
            setting.defaultRule = true;
        }
        return setting;
    }
}

export default MandatoryAndStateSettingsService;
